import { Button, Form, Space } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionViewProps } from ".";
import { ReportStatesEnum } from "../../../../../../constants/constants";


const ResidualRickSection = (props: MitigationSectionViewProps) => {

    const { t } = useTranslation();
    const { data } = props;

    const gotoAppraisal = (state?: ReportStatesEnum) => {
        if (props.gogoAppraisalTool) {
            props.gogoAppraisalTool(state);
        }
    }

    useEffect(() => {
        // setGotoFormDisabled(!data?.further_risk_reduction_required);
    }, [data])

    return (
        <div className="section-wrapper">


            <Form.Item
                label={t("ScenarioMitigation.lbResidualRiskSeverity")}
            >
                <span>
                    {props.data?.residual_risk_severity_impact_control_effectiveness_type?.name}
                </span>
            </Form.Item>

            <Form.Item
                label={t("ScenarioMitigation.lbFurtherRisk")}
            >
                <span>
                    {props.data?.further_risk_reduction_required ? t("Global.lbYes") : t("Global.lbNo")}
                </span>
            </Form.Item>


            <Form.Item
                label={t("ScenarioMitigation.lbFillProjectAppraisalForm")}>
                <Button type="primary" shape="round" disabled={!props.data?.further_risk_reduction_required} 
                onClick={()=> gotoAppraisal(data?.appraisal_tool?.submit_state)}>
                    {t("ScenarioMitigation.lbGoToForm")}
                </Button>
            </Form.Item>


            <Form.Item
                label={t("ScenarioMitigation.lbResidualRiskApprovedLevel")}>
                <Space>
                    <span>
                        {
                            data?.residual_risk_severity_impact_control_effectiveness_type?.from_value
                        }
                    </span>
                    {t("ScenarioMitigation.lbTo")}
                    <span>
                        {
                            data?.residual_risk_severity_impact_control_effectiveness_type?.to_value
                        }
                    </span>
                </Space>

            </Form.Item>

                    <Form.Item
                        label={t("ScenarioMitigation.lbActualLoss")}
                    >
                        <span>
                            {props.data?.actual_loss}
                            </span>
                    </Form.Item>

        </div>
    )
}

export default ResidualRickSection;